import axios from "axios";

export const createOrder = async order => {
    const response = await axios.post(`/api/orders`, { order });
    return response.data;
};

export const updateOrder = async order => {
    const response = await axios.put(`/api/orders`, { order });
    return response.data;
};

export const getOrder = async id => {
    const response = await axios.get(`/api/orders/${id}`);
    return response.data;
};

export const setOrderStatus = async (id, status) => {
    const response = await axios.post(`/api/setorderstatus/${id}/${status}`);
    return response.data;
}

export const createOrderDelivery = async (delivery) => {
    const response = await axios.post(`/api/order/create-delivery`, { delivery });
    return response.data;
}

export const completeOrderDelivery = async (delivery) => {
    const response = await axios.post(`/api/order/complete-delivery`, { delivery: { ...delivery, scans: [] } });
    return response.data;
}

export const cancelOrderDelivery = async (delivery) => {
    const response = await axios.post(`/api/order/cancel-delivery`, { delivery: { ...delivery, scans: [] } });
    return response.data;
}

export const getDelivery = async (id) => {
    const response = await axios.get(`/api/orders/delivery/${id}`);
    return response.data;
}

export const updateDeliveryStatus = async delivery => {
    const response = await axios.put(`/api/order/update-delivery`, { delivery });
    return response.data;
};

export const deleteOrder = async id => {
    const response = await axios.delete(`/api/orders/${id}`);
    return response.data;
}
